import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store';

function App() {
  const user = useSelector((state: RootState) => state.auth.user);

  if (user?.role === 'TEACHER') {
    return <Navigate to="/teacher" replace />;
  }
  
  if (user?.role === 'STUDENT') {
    return <Navigate to="/student" replace />;
  }

  return <Navigate to="/login" replace />;
}

export default App;
